import { env } from "../env";

/**
 * Base URL every API call is built from.
 *
 * This used to be `window.location.origin` — the client was served by the same
 * Express process that answered its requests, so "wherever I came from" was the
 * right answer. It no longer is: the client is static files on Cloudflare and
 * the API is a Heroku dyno somewhere else entirely, so the address has to be
 * stated rather than inferred.
 *
 * Throws rather than falling back to an origin: a bundle that quietly points at
 * the wrong host would 404 every request against Cloudflare's static hosting
 * and read as a routing bug rather than a missing variable. This throw happens
 * in the browser though, so the actual guard is requireApiUrl in
 * vite.config.mts, which refuses to produce the bundle in the first place.
 */
function resolveApiUrl(): string {
	if (env.apiUrl) {
		// One trailing slash, however the variable was written.
		return `${env.apiUrl.replace(/\/+$/, "")}/`;
	}

	if (env.isDev) {
		return "http://localhost:80/";
	}

	throw new Error(
		"VITE_API_URL is not set. A production bundle cannot guess where the API " +
			"lives — set it in the build environment before running `vite build`.",
	);
}

export const rootURL = resolveApiUrl();
